import React from "react";
import Card from "react-bootstrap/Card";
import { useTranslation } from "react-i18next";

function AboutCard({ profile }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language.split("-")[0];

  const content =
    profile?.about?.content?.[lang] ||
    (lang === "uz"
      ? "Admin paneldan о'zingiz haqingizda ma'lumot qo'shing."
      : "Add your about content from Admin Panel.");

  const quote =
    profile?.about?.quote?.[lang] ||
    t("quote", "Strive to build things that make a difference!");

  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <div
            style={{
              textAlign: "justify",
              fontSize: "1.1rem",
              lineHeight: "1.8",
              whiteSpace: "pre-wrap",
            }}
          >
            {content}
          </div>
          <p
            style={{
              color: "rgb(155 126 172)",
              marginTop: "20px",
              fontStyle: "italic",
            }}
          >
            "{quote}"
          </p>
          <footer className="blockquote-footer">
            {profile?.hero?.subtitle?.[lang] || "Saidqodirxon"}
          </footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
